import { AppType } from '@/server'
import { hc } from 'hono/client'

// apiClient is used only on the client, but to avoid errors,
// on the server we can read the env variable for the FRONTEND_ROOT_URL
export const apiClient = hc<AppType>(
  process.env.FRONTEND_ROOT_URL || window.origin,
)
